export default __webpack_public_path__ + "static/media/close.2db7a33e.svg";